export default __webpack_public_path__ + "static/media/CNo.67-6.6ff3c9f0.jpg";